import Tooltip, { type TooltipProps } from './Tooltip';

export type { TooltipProps };
export default Tooltip;
